import { z } from 'zod'

export const dynamicErrorSchema = z
  .object({
    params: z.object({
      detailed_error_description: z.string(),
      detailed_error_severity: z.string(),
      detailed_error_title: z.string(),
      detailed_error_type: z.string(),
    }),
  })
  .transform(({ params }) => params)

export type DetailedErrorParams = z.infer<typeof dynamicErrorSchema>
